import axios from 'axios';

export const instanceRef = {};

export const getDatosPersonaByEmpresa = async (
  celular,
  cedula,
  empresaId,
  token
) => {
  let data;
  const persona = await instanceRef.instance.get('data/persona/empresa', {
    params: {
      celular,
      cedula,
      empresaId,
      token
    }
  });
  data = persona.data.data;
  if (persona?.data?.data) {
    const gettercero = await instanceRef.instance.get('data/personaruc', {
      params: { ruc: persona.data.data.ruc }
    });
    data = {
      ...data,
      tercero: {
        nombres: gettercero.data.data.nombres,
        ruc: gettercero.data.data.ruc,
        celular: gettercero.data.data.celular || '',
        domicilio: gettercero.data.data.domicilio,
        correo: gettercero.data.data.correo
      }
    };
  }
  return data;
};

export const initInstance = (baseUrl) => {
  instanceRef.instance = axios.create({
    baseURL: baseUrl,
    // timeout: 50000,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  });
};

export default instanceRef.instance;
